import { Component } from "@theme/component";
import { ThemeEvents } from "@theme/events";

/**
 * Displays the selected size and reacts to variant changes.
 *
 * Listens on `document` for `variant:update` events so it works regardless of
 * where the variant picker lives in the DOM (e.g. inside a drawer that sits
 * outside the .shopify-section).
 */
export default class ProductSelectedSize extends Component {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate);
  }

  /** @param {import("@theme/events").VariantUpdateEvent} event */
  #handleVariantUpdate = (event) => {
    const { resource, data } = event.detail;
    if (!resource) return;

    if (data.newProduct) {
      this.dataset.productId = data.newProduct.id;
    } else if (data.productId !== this.dataset.productId) {
      return;
    }

    const label = this.querySelector("[data-size-label]");
    if (!label) return;

    const newLabel = data.html?.querySelector("product-selected-size [data-size-label]");
    if (newLabel) {
      label.innerHTML = newLabel.innerHTML;
    } else {
      label.textContent = resource.option1 ? `${resource.option1}` : (label.dataset.defaultText ?? "");
    }
  };
}

if (!customElements.get("product-selected-size")) {
  customElements.define("product-selected-size", ProductSelectedSize);
}
